/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export const tableOfContents = [];
export const title = "Datagame.live updates";
export const date = "2023-04-25";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, props.components);
  return _jsxs(_components.p, {
    children: ["I finished testing ", _jsx(_components.a, {
      href: "https://github.com/dylanburati/datagame.live/pull/3",
      children: "changes"
    }), " to my trivia app which made\nquestions more varied and the game more competitive. I also\nrefactored the data collection notebooks to make use of\nWikipedia and Wikidata (blog post to come)."]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
